import { WC_PRODUCTS } from "../../services/wc"
import { PRODUCT_TYPES } from "../types"

export function getProductsAction(params){
    return async (dispatch) => {

        dispatch(notifyStatus(PRODUCT_TYPES.GET_PRODUCTS,true))

        await WC_PRODUCTS.getProducts({...params}).then(result=>{
            if(result.status === 200){

                dispatch(notifyStatus(PRODUCT_TYPES.GET_SUCCESS,false))
                dispatch(showData(PRODUCT_TYPES.SHOW_PRODUCTS,result.data))

            }
        })
        .catch(error=>{
            console.log(error)
            dispatch(notifyStatus(PRODUCT_TYPES.GET_ERROR,true))
        })

    }
}

export function loadMoreProducts (params) {
    return async (dispatch) => {

        dispatch(notifyStatus(PRODUCT_TYPES.GET_PRODUCTS,true))

        await WC_PRODUCTS.getProducts({...params}).then(result=>{
            if(result.status === 200){

                dispatch(notifyStatus(PRODUCT_TYPES.GET_SUCCESS,false))
                dispatch(showData(PRODUCT_TYPES.SHOW_MORE_PRODUCTS,result.data))

            }
        })
        .catch(error=>{
            console.log(error)
            dispatch(notifyStatus(PRODUCT_TYPES.GET_ERROR,true))
        })

    }
}

export function getCategoriesAction(params){
    return async (dispatch) => {
        dispatch(notifyStatus(PRODUCT_TYPES.GET_CATEGORIES,true))
        await WC_PRODUCTS.getCategories({...params})
        .then( result => {
            dispatch(notifyStatus(PRODUCT_TYPES.GET_SUCCESS,false))
            dispatch(showData(PRODUCT_TYPES.SHOW_CATEGORIES,result.data))
        })
        .catch( error => {
            dispatch(notifyStatus(PRODUCT_TYPES.GET_ERROR,true))
        })
    }
}

export function getProductById(id){
    return async (dispatch) => {
        dispatch(notifyStatus(PRODUCT_TYPES.GET_PRODUCTS, true))
        await WC_PRODUCTS.getProduct(id)
        .then( result => {
            dispatch(notifyStatus(PRODUCT_TYPES.GET_SUCCESS,false))
            dispatch(showData(PRODUCT_TYPES.SHOW_PRODUCT,result.data))
        })
        .catch(error =>{
            dispatch(notifyStatus(PRODUCT_TYPES.GET_ERROR,true))
        })
    }
}

export function setProduct(product){
    return (dispatch) => {
        dispatch(showData(PRODUCT_TYPES.SHOW_PRODUCT,product))
    }
}

const showData = (type, data) => ({
    type:type,
    payload:data
})

const notifyStatus = (type, status) => ({
    type:type,
    payload:status
})
